import React, {Component} from 'react';
import {connect} from 'react-redux'
import bindAll from 'lodash.bindall';
import EvaluateComponent from '../components/evaluate/evaluateclass.jsx';
import {getXueyuanListRequest, getReasonListRequest,dianzanStudentDanRequest,dianzanStudentDuoRequest,getClassReasonListRequest,pingjiaClassRequest} from "../service/reason";


class EvaluateContainer extends React.Component {

    constructor(props) {
        super(props)
        bindAll(this, [
            'clickXueyuan',
            'clickXueke',
            'clickLiyou',
            'clickHonglingjinTab',
            'clickTab'
        ]);
        this.state = {
            option: {},
            num: 9,
            xueyuanList: [],
            xueyuan_code: '',
            xueyuan_name: '',
            xuekeList: [],
            xueke_code: '',
            xueke_name: '',

            class_code: props.banji_code,
            honglingjinTab: 0,
            jichuZhangList: [],
            teseZhangList: [],
            yixingData: {},
            laodongJiatingList: [],
            laodongXuexiaoList: [],
            laodongShehuiList: [],
            isClick:true,
            tab:0,
            dianzanList:[],
            gaijinList:[],
            liyouList: [],
        }

    }

    componentDidMount() {
        // getXueyuanListRequest(this.state.class_code, (data) => {
        //     console.log(data)
        //
        //     if (data.data == '') {
        //
        //     } else {
        //         this.setState({
        //             xueyuanList: data.data.xueke,
        //             xueyuan_code: data.data.xueke[0].xueyuan_code,
        //             xuekeList: data.data.xueke[0].xueyuan_xueke,
        //             xueke_code: data.data.xueke[0].xueyuan_xueke[0].xueke_code
        //         })
        //         this.getReasonList(data.data.xueke[0].xueyuan_xueke[0].xueke_code)
        //     }
        // });

        this.getClassReasonList('0')
    }

    clickTab(tab){

        if(tab==this.state.tab){

        }else {
            if(tab==0){
                var list = this.state.dianzanList[0].liyou
                this.setState({
                    liyouList: list,
                    xueke_code:this.state.dianzanList[0].fenlei_code
                })
            }else if(tab==1){
                var list = this.state.gaijinList[0].liyou
                this.setState({
                    liyouList: list,
                    xueke_code:this.state.dianzanList[0].fenlei_code
                })
            }
        }



        this.setState({
            tab:tab
        })
    }

    getClassReasonList(type) {
        getClassReasonListRequest(type, (data) => {
            console.log(data)
            if(data.ret=='1'){
                this.setState({
                    dianzanList:data.data.dianzan,
                    gaijinList:data.data.daigaijin,
                    liyouList:data.data.dianzan[0].liyou
                })
            }
        });
    }

    getReasonList(xueke_code) {
        getReasonListRequest(this.state.class_code, xueke_code, (data) => {
            console.log(data)

            if (data.data == '') {

            } else {
                if (xueke_code == '26') {
                    this.setState({
                        jichuZhangList: data.data.data_jichu,
                        teseZhangList: data.data.data_tese,
                        yixingData:data.data.data_yixing
                    })

                } else if (xueke_code == '27') {
                    this.setState({
                        laodongJiatingList: data.data.data_jiating,
                        laodongXuexiaoList: data.data.data_xuexiao,
                        laodongShehuiList: data.data.data_shehui
                    })
                } else {
                    this.setState({
                        liyouList: data.data.zhibiao

                    })
                }
                // this.setState({
                //     liyouList:data.data.zhibiao
                //
                // })
            }
        });
    }

    showToast(msg,duration){
        duration=isNaN(duration)?3000:duration;
        var m = document.createElement('div');
        m.innerHTML = msg;
        m.style.cssText="min-width:180px; background:#000; opacity:0.6; height:auto;min-height: 30px; color:#fff; line-height:30px; text-align:center; border-radius:4px; position:fixed; top:45%; left:50%;transform: translate(-50%,-50%);padding:15px; z-index:999999;";
        document.body.appendChild(m);
        setTimeout(function() {
            var d = 0.5;
            m.style.webkitTransition = '-webkit-transform ' + d + 's ease-in, opacity ' + d + 's ease-in';
            m.style.opacity = '0';
            setTimeout(function() { document.body.removeChild(m) }, d * 1000);
        }, duration);
    }

    clickXueyuan(xueyuan_code, index) {
        if (xueyuan_code == this.state.xueyuan_code) {

        } else {
            this.getReasonList(this.state.xueyuanList[index].xueyuan_xueke[0].xueke_code)
        }
        this.setState({
            xueyuan_code: xueyuan_code,
            xuekeList: this.state.xueyuanList[index].xueyuan_xueke,
            xueke_code: this.state.xueyuanList[index].xueyuan_xueke[0].xueke_code
        })
    }

    clickXueke(code, index) {
        if (code == this.state.xueke_code) {

        } else {
            if(this.state.tab==0){
                var list = this.state.dianzanList[index].liyou
                this.setState({
                    liyouList: list
                })
            }else if(this.state.tab==1){
                var list = this.state.gaijinList[index].liyou
                this.setState({
                    liyouList: list
                })
            }
        }
        this.setState({
            xueke_code: code
        })


    }

    clickLiyou(dianzan_code) {

        console.log(dianzan_code)

        const { isClick } = this.state;

        if(isClick) {
            this.setState({isClick: false});

            var type = this.state.tab==0?'1':'2';

                pingjiaClassRequest(this.props.banji_code, type,dianzan_code, (data) => {
                    const that = this;  // 为定时器中的setState绑定this
                    setTimeout(function () {       // 设置延迟事件，1秒后将执行
                        that.setState({ isClick: true })   // 将isClick设置为true
                    }, 1000);

                    console.log(data)
                    if (data.ret == '1') {
                        this.props.pingjiaClassFinish();
                    } else {
                        this.showToast(data.msg, 1500)
                    }

                })

        }

    }

    clickHonglingjinTab(tab) {
        this.setState({
            honglingjinTab: tab
        })
    }

    render() {

        return (
            <EvaluateComponent
                student_name={this.props.student_name}
                xueyuanList={this.state.xueyuanList}
                xueyuan_code={this.state.xueyuan_code}
                onRequestClose={this.props.closeSelf}
                clickXueyuan={this.clickXueyuan}
                xuekeList={this.state.xuekeList}
                xueke_code={this.state.xueke_code}
                currentXueke={this.state.currentXueke}
                clickXueke={this.clickXueke}
                liyouList={this.state.liyouList}
                clickLiyou={this.clickLiyou}
                honglingjinTab={this.state.honglingjinTab}
                clickHonglingjinTab={this.clickHonglingjinTab}
                jichuZhangList={this.state.jichuZhangList}
                teseZhangList={this.state.teseZhangList}
                yixingData={this.state.yixingData}
                laodongJiatingList={this.state.laodongJiatingList}
                laodongXuexiaoList={this.state.laodongXuexiaoList}
                laodongShehuiList={this.state.laodongShehuiList}
                tab={this.state.tab}
                clickTab={this.clickTab}
                dianzanList={this.state.dianzanList}
                gaijinList={this.state.gaijinList}
            />
        )
    }

}

EvaluateContainer.propTypes = {
    // count: PropTypes.Number.isRequired,
}


const mapStateToProps = state => {
    return {
        msg: state.alert.msg,
        status: state.alert.status,
    }
}

const mapDispatchToProps = dispatch => {
    return {}
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(EvaluateContainer);
